import ColumnSettings from './columnSettings'
export default ColumnSettings
